<template>
  <div>
    <div class="card">
  <div class="card-header">
    Nachfolgeprojekt
  </div>
  <div class="card-body">
    <p class="card-text">Eröffne ein neues Projekt, welches auf dem aktuellen Projekt basiert. Das hier verfügbare Projekt wird automatisch archiviert.</p>
    <button class="btn btn-primary" @click="showModal = true">Nachfolgeprojekt eröffnen</button>
  </div>
    <b-modal
      v-model="showModal"
      title="Projektdetails"
      @ok="handleOk"
    >
      <form @submit.prevent="handleSubmit">
        <p class="text-danger">Achtung: Das aktuelle Projekt wird automatisch archiviert</p>
        <div class="form-group">
          <label for="newProjectName">Neuer Projektname</label>
          <input type="text" class="form-control" id="newProjectName" v-model="newProjectName">
        </div>
        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input" id="transferTimes" v-model="transferTimes">
          <label class="form-check-label" for="transferTimes">Zeiten auf neues Projekt übertragen?</label>
        </div>
        <div v-if="transferTimes" class="form-group">
          <label for="additionalDate">Zeiten ab diesem Datum auf neues Projekt übernehmen</label>
          <vuejs-datepicker v-model="transferWorklogsDateTimeFrom"></vuejs-datepicker>
        </div>
      </form>
    </b-modal>
    </div>
     <b-spinner v-if="loading" label="Loading..."></b-spinner>
  </div>
</template>

<script>
import { STOREMODULE_ENDPOINT_MAP, STOREMODULE_ENDPOINTMODULE_MAP } from '@/constants'
import http from '@/$plugins/http'
import VuejsDatepicker from 'vuejs-datepicker'
import { BModal } from 'bootstrap-vue'

export default {
  name: 'Projects.Operations',
  components: {
    VuejsDatepicker,
    BModal
  },
  data () {
    return {
      showModal: false,
      loading: false,
      newProjectName: '',
      transferTimes: false,
      transferWorklogsDateTimeFrom: null,
      projectId: ''
    }
  },
  created () {
    const urlParts = window.location.pathname.split('/')
    const projectId = urlParts[urlParts.length - 2] // Extract the second-to-last part from the URL path
    this.projectId = projectId
  },
  methods: {
    async handleOk () {
      if (!this.newProjectName) {
        alert('Bitte gib einen Namen für das neue Projekt ein.')
        return
      }
      this.loading = true
      try {
        const endpoint = `/${STOREMODULE_ENDPOINTMODULE_MAP.business}/api/${STOREMODULE_ENDPOINT_MAP.projects}/${this.projectId}/createfollowupproject`
        const payload = {
          projectId: this.projectId,
          newProjectName: this.newProjectName,
          transferWorklogsDateTimeFrom: this.transferWorklogsDateTimeFrom
        }
        const response = await http.post(endpoint, payload)
        if (response.data && response.data.success && response.data.result) {
          const newProjectId = response.data.result.id
          this.$router.push(`/projects/${newProjectId}/detail`)
        } else {
          alert('Fehler beim Erstellen des Nachfolgeprojekts.')
        }
      } catch (error) {
        console.error(error)
        alert('Fehler beim Eröffnen des Nachfolgeprojekts.')
      }
      this.loading = false
      this.showModal = false
    }
  }
}
</script>

<style lang="scss"></style>
